<template>
  <div>
    <b-modal
      ref="modal"
      scrollable
      :size="modalBModalSize"
      hide-footer
      @show="onShow"
    >
      <template #modal-header>
        <h5 class="modal-title mr-auto">
          <i class="fas fa-circle-nodes mr-2" style="color: #472282"></i>
          Conectores
          <!-- Aberto pela Central: deixa explícito de que conta são os
          conectores, pra não editar a conta errada achando que é a sua. -->
          <span v-if="contaNome" class="modal-conta-inline ml-2">
            <i class="fas fa-building mr-1"></i>{{ contaNome }}
          </span>
        </h5>
        <div class="d-flex align-items-center buttons-container">
          <b-button
            v-if="navSelecionada !== 1"
            size="sm"
            variant="light"
            @click="voltarParaListagem"
          >
            Listagem
          </b-button>
          <b-dropdown text="Baixar Conector" size="sm" variant="info">
            <b-dropdown-item
              href="https://s3.us-east-2.amazonaws.com/media.comunicante.net.br/agente/comunicante-agente-32.zip"
              >Datanet 32bits</b-dropdown-item
            >
            <b-dropdown-item
              href="https://s3.us-east-2.amazonaws.com/media.comunicante.net.br/agente/comunicante-agente-64.zip"
              >Datanet 64bits (x64)</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            v-if="navSelecionada !== 0"
            size="sm"
            variant="success"
            @click="abrirNovoConector"
          >
            Novo Conector
          </b-button>
          <b-button
            v-if="navSelecionada !== 2"
            size="sm"
            variant="warning"
            @click="redirectNewSystem"
          >
            Novo Sistema
          </b-button>
        </div>
        <b-button variant="link" class="p-0 ml-3" @click="$refs.modal.hide()">
          <i class="fas fa-times fa-lg" style="color: #b5b5c3"></i>
        </b-button>
      </template>

      <div ref="modalContainer">
        <Toast position="top-right" />

        <Transition name="fade" appear :duration="{ enter: 500, leave: 800 }">
          <div v-if="navSelecionada == 0">
            <h2 class="text-center">
              {{ edicaoConector ? "Editar" : "Cadastrar" }} Conector
            </h2>
            <br />
            <form ref="form" @submit.stop.prevent="salvarConector">
              <b-form-group
                label="Descrição"
                label-for="descricao-input"
                invalid-feedback="Descrição é necessária"
              >
                <b-form-input
                  id="descricao-input"
                  v-model="licDescricao"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Status"
                label-for="status-select"
                invalid-feedback="Selecione um status"
              >
                <b-form-select
                  id="status-select"
                  v-model="licStatus"
                  :options="['ATIVO', 'INATIVO', 'SUSPENSO']"
                >
                </b-form-select>
              </b-form-group>

              <b-button
                class="btn-agente-sistema w-100"
                variant="success"
                @click="salvarConector"
                >Salvar</b-button
              >
            </form>
          </div>
          <div v-else-if="navSelecionada == 1">
            <PainelConectores
              ref="painelConectores"
              class="aut-camp-area"
              :contaId="contaId"
              @editar-licenciada="editarLicenciada"
              @editar-conector="editarConector"
            />
          </div>
          <div v-else-if="navSelecionada == 2">
            <CadastroLicenciada
              :cadastro="cadastroLicenciada"
              :licenciadaSelecionadaId="licenciadaSelecionadaId"
              :contaId="contaId"
              @cadastrarEditarLicenciada="atualizarListaLicenciada"
              @redirecionarParaCadastrarAgente="redirecionarParaCadastarAgente"
              @redirectSemMudancas="redirectSistemaSemMudancas"
            />
          </div>
        </Transition>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PainelConectores from "./PainelConectores.vue";
import CadastroLicenciada from "../licenciada/CadastroLicenciada.vue";
import ApiService from "@/core/services/api.service";
import API_LINKS from "../api.links";
import Toast from "primevue/toast/Toast";

export default {
  components: {
    PainelConectores,
    CadastroLicenciada,
    Toast
  },
  data() {
    return {
      contaId: null,
      contaNome: "",
      navSelecionada: 1,
      licDescricao: "",
      licStatus: "",
      licenciadaEdicaoId: null,
      conectorContaId: null,
      conectorToken: null,
      edicaoConector: false,
      cadastroLicenciada: true,
      licenciadaSelecionadaId: null
    };
  },
  methods: {
    // contaId nulo = tela da própria conta logada (usado na Home, ao
    // expandir); com contaId, é a tela daquela conta (Central de Contas).
    abrir(contaId = null, contaNome = "") {
      this.contaId = contaId || null;
      this.contaNome = contaNome || "";
      this.$nextTick(() => {
        this.$refs.modal.show();
      });
    },

    onShow() {
      this.navSelecionada = 1;
    },

    voltarParaListagem() {
      this.navSelecionada = 1;
      this.$nextTick(() => {
        this.$refs.painelConectores && this.$refs.painelConectores.pegarDados();
      });
    },

    abrirNovoConector() {
      this.licDescricao = "";
      this.licStatus = "";
      this.licenciadaEdicaoId = null;
      this.conectorContaId = null;
      this.conectorToken = null;
      this.edicaoConector = false;
      this.navSelecionada = 0;
    },

    editarConector(item) {
      this.licDescricao = item.lic_descricao;
      this.licStatus = item.lic_status == "A" ? "ATIVO" : "INATIVO";
      this.licenciadaEdicaoId = item.licenciada_id;
      // REGRAS_EDITAR exige conta_id e lic_token junto -- guardo os dois do
      // registro original em vez de espalhar o objeto inteiro, que vem
      // enriquecido com campos de UI (online, qtdSistemas) e cairia no
      // mass-assignment do updateOrCreate.
      this.conectorContaId = item.conta_id;
      this.conectorToken = item.lic_token;
      this.edicaoConector = true;
      this.navSelecionada = 0;
    },

    redirectNewSystem() {
      this.navSelecionada = 2;
      this.licenciadaSelecionadaId = null;
      this.cadastroLicenciada = true;
    },
    redirectSistemaSemMudancas() {
      this.navSelecionada = 1;
      this.$toast.add({
        severity: "warn",
        summary: "Sem mudanças",
        detail: "Não houve mudanças no cadastro.",
        life: 7000
      });
    },
    redirecionarParaCadastarAgente() {
      this.abrirNovoConector();
    },
    atualizarListaLicenciada() {
      this.navSelecionada = 1;
      this.$emit("atualizarListagemDeCampanha");
      this.$nextTick(() => {
        this.$refs.painelConectores && this.$refs.painelConectores.pegarDados();
      });
    },
    editarLicenciada(licenciadaId) {
      this.cadastroLicenciada = false;
      this.licenciadaSelecionadaId = licenciadaId;
      this.navSelecionada = 2;
    },
    salvarConector() {
      // O backend guarda só a inicial (A/I/S). Sem status escolhido isso
      // virava undefined e voltava um 400 sem explicação na tela.
      if (!this.licStatus) {
        this.$toast.add({
          severity: "warn",
          summary: "Selecione um status",
          detail: "Escolha o status do conector antes de salvar.",
          life: 5000
        });
        return;
      }

      this.licStatus = this.licStatus[0];
      const emEdicao = !!this.licenciadaEdicaoId;

      const licenca = {
        lic_descricao: this.licDescricao,
        lic_status: this.licStatus
      };

      // REGRAS_EDITAR (LicenciadaBusiness) exige licenciada_id, conta_id e
      // lic_token além dos campos do formulário — sem eles o backend
      // devolve 400. O formulário antigo não tropeçava nisso porque
      // espalhava o registro inteiro no payload.
      if (emEdicao) {
        licenca.licenciada_id = this.licenciadaEdicaoId;
        licenca.conta_id = this.conectorContaId;
        licenca.lic_token = this.conectorToken;
      }

      const payload = { licenca };

      // Criando pela Central: sem o conta_id o conector nasceria na conta
      // do super admin, não na conta que ele está vendo.
      if (!emEdicao && this.contaId) {
        payload.conta_id = this.contaId;
      }

      ApiService.post(
        API_LINKS.licenca + (emEdicao ? "/" + this.licenciadaEdicaoId : ""),
        payload
      )
        .then((response) => {
          if (response.data["erro"] != "undefined") {
            this.$toast.add({
              severity: "success",
              summary: "Conector " + (emEdicao ? "atualizado" : "cadastrado"),
              detail: "Você já pode usar o conector nos seus sistemas!",
              life: 7000
            });
          }
          this.atualizarListaLicenciada();
        })
        .catch((erro) => {
          // Sem isto o 400 só aparecia no console e a tela ficava parada,
          // sem dizer o que faltou.
          const dados = erro?.response?.data?.erro;
          const detalhe =
            dados && typeof dados === "object"
              ? Object.values(dados).flat().join(" ")
              : "Não foi possível salvar o conector.";

          this.$toast.add({
            severity: "error",
            summary: "Erro ao salvar o conector",
            detail: detalhe,
            life: 7000
          });
        });
    }
  },
  computed: {
    modalBModalSize() {
      if (window.screen.width > 900) return "xl";
      return "md";
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
// No cabeçalho, ao lado do título — sem largura fixa (foi o que quebrava
// "Novo Conector" em duas linhas e dobrava a altura do botão).
.buttons-container {
  gap: 0.5rem;
  white-space: nowrap;
}
</style>
